import { render, staticRenderFns } from "./Template1.vue?vue&type=template&id=4a54dabe"
import script from "./Template1.vue?vue&type=script&lang=js"
export * from "./Template1.vue?vue&type=script&lang=js"
import style0 from "./Template1.vue?vue&type=style&index=0&id=4a54dabe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports